import React, { useState } from 'react';
import { WizardStepProps } from '../WizardStepProps';
import { DetailsStep } from '../01_detailsStep/DetailsStep';
import { ProgressStep } from '../shared/WizardProgress';
import { useWizardStep } from '../useWizardStep';
import { CreateSigningAppointmentFormData } from '../04_confirmationStep/convertToCreateSigningAppointmentRequest';
import { SignersForm } from './signersForm/SignersForm';
import { SignersStepNavigation } from './SignersStepNavigation';
import { MethodStep } from '../03_methodsStep/MethodStep';
import { FormTemplate } from '../shared/FormTemplate';

export const SignersStep: React.FC<WizardStepProps> = ({ wizardFormData, ...rest }) => {
  const { showNext, showPrevious, advance, goBack } = useWizardStep();

  const [updatedWizardFormData, setUpdatedWizardFormData] = useState<CreateSigningAppointmentFormData>(wizardFormData);

  if (showPrevious) {
    return <DetailsStep wizardFormData={updatedWizardFormData} {...rest} />;
  }

  if (showNext) {
    return <MethodStep wizardFormData={updatedWizardFormData} {...rest} />;
  }

  return (
    <FormTemplate progressStep={ProgressStep.SIGNERS} wizardFormData={wizardFormData}>
      <section className={'mt-3'}>
        <h5 className={'mb-4 text-base font-medium leading-5'}>{`Signers*`}</h5>
        <SignersForm
          advance={advance}
          updatedWizardFormData={updatedWizardFormData}
          setUpdatedWizardFormData={setUpdatedWizardFormData}
          {...rest}
        >
          <SignersStepNavigation goBack={goBack} />
        </SignersForm>
      </section>
    </FormTemplate>
  );
};
